
import { Doctor, Service, Testimonial } from './types';

export const doctors: Doctor[] = [
  {
    id: '1',
    name: 'Dr. Chrissy Du Plessis',
    role: 'General Practitioner',
    subRole: 'Owner',
    category: 'GP',
    image: 'https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Chrissy.avif',
    expertise: ['Internal Medicine', 'Chronic Disease Management', 'Preventative Care'],
    description: 'Dr Chrissy is a medical doctor who graduated from the University of Cape Town in 2003. She has worked in Internal medicine and explored her interest in the management of chronic diseases working in general practice and family medicine focusing on individualised patient management with an emphasis on preventative primary health care. In 2013 she took the leap to open a practice of her own and thus Dr CG Du Plessis and Partners came into existence.',
    badge: 'Owner'
  },
  {
    id: '2',
    name: 'Dr. Lochi Kanagaratnam',
    role: 'General Practitioner',
    subRole: 'Co-Owner',
    category: 'GP',
    image: 'https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Lochi.avif',
    expertise: ['Paediatrics', 'Neonatal ICU', 'HIV Management'],
    description: 'Dr. K studied at the University of Witwatersrand and completed her medical degree there in 2008. She spent the next 3 years working in paediatrics, including neonatal and paediatric ICU and paediatric HIV management; during which time she completed her post-graduate Diploma in Child Health. Dr K joined the practice in 2016 and became a partner in 2020.',
    badge: 'Co-Owner'
  },
  {
    id: '3',
    name: 'Dr. Miranda Mogane',
    role: 'General Practitioner',
    subRole: 'Associate',
    category: 'GP',
    image: 'https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Miranda.avif',
    expertise: ['Occupational Health', 'Preventative Medicine', 'Nephrology'],
    description: 'Dr Miranda graduated in 2017 at the University of Cape Town as a medical doctor. She has five years clinical experience in Family Medicine, Internal Medicine & Nephrology. Her special interests are in Public Health, specifically Occupational Healthcare, and Preventive Medicine. She joined us as a locum in 2024 and has since become a permanent addition to the team.'
  },
  {
    id: '4',
    name: 'Sr. Terri Milne',
    role: 'Registered Nurse',
    subRole: 'Nursing Sister',
    category: 'GP',
    image: 'https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Terri.avif',
    expertise: ['Neonatal ICU', 'General Nursing'],
    description: 'Sister Terri is a qualified, registered Nursing Sister. She graduated from B.G. Alexander Nursing College in 1996 and spent 4 years working in the neonatal ICU at Olivedale Clinic, and as working mother she has a wealth of personal experience to add to her professional advice. Sister Terri has been part of the team since 2018.',
    badge: 'Nursing Sister'
  },
  {
    id: '5',
    name: 'Thandi Skhosana',
    role: 'Receptionist',
    subRole: 'Administration',
    category: 'GP',
    image: 'https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Thandi.avif',
    expertise: ['Medical Reception', 'Administration'],
    description: 'Thandi joined in 2019, she is a highly organised medical receptionist with over seven years’ experience in a GP office environment.'
  },
  {
    id: '6',
    name: 'Lindy Zulu',
    role: 'Receptionist',
    subRole: 'Administration',
    category: 'GP',
    image: 'https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Lindiwe.avif',
    expertise: ['Front Desk', 'Patient Relations'],
    description: 'Lindy joined us in 2024, she is friendly and engaging with over 4 years’ experience in the field.'
  }
];

export const services: Service[] = [
  {
    id: '1',
    icon: 'stethoscope',
    title: 'General Medical Consultations',
    description: 'Comprehensive routine check-ups and personalized health assessments to ensure your ongoing well-being.',
    longDescription: 'Our comprehensive medical examinations provide a thorough assessment of your current health status. We cover full history taking, detailed physical examinations including vital signs, cardiovascular assessment, respiratory checks, and abdominal examinations. We also provide preventative screening advice tailored to your age and risk profile, ensuring early detection of potential health issues. Includes supplying the necessary medical certificates needed for specific check-ups for the purposes of insurance procedures, pre-employment, adoption medicals, or for immigration and emigration.',
    actionText: 'Learn More'
  },
  {
    id: '2',
    icon: 'medication',
    title: 'Nursing Services',
    description: 'Professional care from our dedicated clinic sister, including wound care, vaccinations, and vitals monitoring.',
    longDescription: 'Our nursing department offers a wide range of essential clinical services. From routine vaccinations (such as Flu) and immunizations to specialized wound care and dressing changes. We also perform vital monitoring (blood pressure, glucose, cholesterol), baby immunisation and wellness, Discovery Vitality health checks, and administration of injectables as prescribed by our doctors.',
    actionText: 'View Services'
  },
  {
    id: '3',
    icon: 'healing',
    title: 'Chronic Disease Management',
    description: 'Consistent, attentive management of ongoing conditions.',
    longDescription: 'Chronic medical conditions refer to problems which are more persistent and extend over a long period of time. We specialize in the diagnosis and ongoing management of chronic conditions such as Hypertension, Diabetes, Asthma, and Arthritis. Our approach involves regular monitoring, medication adjustment, and lifestyle coaching to prevent complications.',
    actionText: 'Learn More'
  },
  {
    id: '9',
    icon: 'emergency',
    title: 'Acute Disease Management',
    description: 'Prompt care for acute illnesses such as coughs, colds and flus, skin problems, diarrhoea, nausea and vomiting.',
    longDescription: 'Acute health problems refer to incidents that are sudden and often of short duration. For acute illnesses like flu, infections, or minor injuries, we provide immediate and effective treatment. The acute illnesses include coughs, colds, flus, skin problems, rashes, acne, allergic reactions, etc, stress, insomnia, depression, anxiety, gastro-enteritis, diarrhoea, nausea, vomiting, headaches, tiredness, fatigue, and injuries such as sprained ankles or wrists.',
    actionText: 'Learn More'
  },
  {
    id: '4',
    icon: 'female',
    title: 'Women’s Health',
    description: 'Specialized care designed for women, covering preventative screenings, reproductive health, and wellness.',
    longDescription: 'Although there is usually an emphasis on obstetrics, gynaecology and gynaecological problems, women\'s health related issues can range from problems concerning menstruation, maternal health and child birth, to menopause and female predominated cancers, such as breast cancer and ovarian cancer. Dedicated to women\'s well-being, we offer Pap smears, breast examinations, sexual health screenings, menopause management, skin and aesthetic health and testing for Human Papillomavirus (HPV) as well as HPV vaccines. We provide counselling on contraception, libido, family planning, depression and anxiety ensuring a supportive environment for discussing sensitive health concerns.',
    actionText: 'Learn More'
  },
  {
    id: '6',
    icon: 'male',
    title: 'Men’s Health',
    description: 'Targeted health strategies for men, including preventative screenings and lifestyle optimization.',
    longDescription: 'The area of men\'s health focuses on male specific health issues, especially diseases that affect men exclusively or more frequently than women. Focusing on the specific health needs of men, we offer prostate screenings, cardiovascular risk assessments, hypertension, heart attack, diabetes, peptic ulcers, and testosterone level checks. We also provide support for lifestyle changes, stress and depression management, and sexual health issues, promoting longevity and vitality.',
    actionText: 'Learn More'
  },
  {
    id: '5',
    icon: 'child_care',
    title: 'Children’s Health',
    description: 'Gentle, informed medical care for children, fostering healthy growth in a comforting environment.',
    longDescription: 'Paediatricians are often expensive and sometimes it can be difficult to book specialist appointments. We understand that children need a gentle touch. Our services cover developmental milestones, routine immunisations, diseases of childhood like measles or chickenpox, and the management of common childhood ailments like fevers, constipation, croup, nappy rashes, cradle cap, tonsillitis, diarrhoea, vomiting and respiratory infections. We strive to create a fear-free environment for our younger patients.',
    actionText: 'Learn More'
  },
  {
    id: '7',
    icon: 'elderly',
    title: 'Geriatric Care',
    description: 'Compassionate medical support tailored to the unique needs of older patients, ensuring dignity and quality of life.',
    longDescription: 'Senior citizens and the very elderly tend to be an overlooked population in South Africa. Our geriatric services are aimed at supporting healthy aging. We manage age-related conditions, polypharmacy (reviewing multiple medications), and frailty. These include hypertension, diabetes, thyroid dysfunction, heart failure, angina, and atrial fibrillation. We also screen for cognitive decline, dementia, various cancers, and work closely with families to ensure our elderly patients maintain their dignity and quality of life.',
    actionText: 'Learn More'
  },
  {
    id: '8',
    icon: 'surgical',
    title: 'Minor Procedures',
    description: 'Expertly performed minor procedures done on-site in our safe, professional environment.',
    longDescription: 'There are several conditions that require minor surgical procedures to be conducted by medical practitioners. Our practice is equipped to handle minor procedures in a sterile and safe environment. Depending on size and extent of the lesion, this includes suturing, stitching of wounds, removal of warts, molluscum, sunspots, moles or other small skin lesions, drainage of abscesses, and biopsy of any suspicious skin lesions. We also offer non-surgical procedures such as ECG, ear wax removal, and nebulisation.',
    actionText: 'View Details'
  },
  {
    id: '10',
    icon: 'vaccines',
    title: 'IV Wellness Therapy',
    description: 'Intravenous wellness solutions for recovery, hydration, energy, and immune support.',
    longDescription: 'As part of our commitment to a holistic approach to patient welfare we offer a variety of intravenous (IV) solutions to aid patients in terms of recovery (overindulgence, post-op convalescence or stress relief), hydration/energy (post strenuous events: marathons), and immune boosters (preventative action). We offer the following therapies: Fatigue Recovery Drips (overindulgence, post-op convalescence or stress relief), Immune Booster Drips (preventative action), Hydration Drips (post strenuous events eg marathons), Hangover Drips (overindulgence), and Detox Drips.',
    actionText: 'Learn More'
  }
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    rating: 5,
    text: "The level of care and personal attention I received was truly life-changing. I felt heard and respected throughout my entire treatment journey.",
    author: "Sarah Jenkins",
    location: "Fourways, Sandton",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150"
  },
  {
    id: '2',
    rating: 5,
    text: "I didn't believe that this level of professional service still existed. From the modern facilities to the expert advice, everything was seamless.",
    author: "Marcus D.",
    location: "Sandton, SA",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150"
  },
  {
    id: '3',
    rating: 5,
    text: "Professional and thorough. Dr. Du Plessis took the time to explain everything clearly. Highly recommended for chronic care management.",
    author: "James Wilson",
    location: "Lonehill, Sandton",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150"
  },
  {
    id: '4',
    rating: 5,
    text: "Fantastic pediatric care. My kids are actually excited to visit the doctor now. Such a welcoming and comforting environment for little ones.",
    author: "Elena Rodriguez",
    location: "Dainfern, Sandton",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150"
  }
];

export const heroSlides = [
  "https://ik.imagekit.io/6dlukcyok/Medical%20bucket/pexels-jo-mcnamara-185550273-11288665.jpg",
  "https://ik.imagekit.io/6dlukcyok/Medical%20bucket/ChatGPT%20Image%20Feb%2018,%202026,%2004_32_36%20PM.png",
  "https://ik.imagekit.io/6dlukcyok/Medical%20bucket/pexels-mart-production-7088841.jpg"
];

export interface ProcessStep {
  id: string;
  title: string;
  description: string;
  icon: string;
  image: string;
  stats: { label: string; value: string }[];
}

export const processSteps: ProcessStep[] = [
  {
    id: '01',
    title: 'Book an Appointment',
    description: 'Choose the appointment time that best fits your busy schedule with our easy-to-use online booking system. Available 24/7, you can quickly and securely book your visit anytime, from anywhere.',
    icon: 'calendar_month',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=1200',
    stats: [
      { label: 'Avg. Booking Time', value: '2 mins' }
    ]
  },
  {
    id: '02',
    title: 'Meet Your Doctor',
    description: 'Receive personalized care designed just for you by our team of licensed medical professionals. We focus on understanding your unique health needs, providing expert treatment and support.',
    icon: 'medical_services',
    image: 'https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Miranda.avif',
    stats: [
      { label: 'Expert Doctors', value: '3' }
    ]
  },
  {
    id: '03',
    title: 'Begin Your Treatment',
    description: 'Start your personalized care plan with full support and expert guidance. Our team stays with you every step, offering regular updates to ensure your health journey is smooth and effective.',
    icon: 'prescriptions',
    image: 'https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&q=80&w=1200',
    stats: [
      { label: 'Care Support', value: 'Active' }
    ]
  }
];

export const faqs = [
  {
    question: "What medical schemes do you currently accept?",
    answer: "We work with all major medical schemes including Discovery, Momentum, and Medshield. Our doctors are on the Discovery Network as Premier Plus Doctors."
  },
  {
    question: "Do you offer emergency medical services?",
    answer: "No, please note that we do not have the equipment available on our premises for emergency situations. We recommend that you seek immediate hospital admission."
  },
  {
    question: "Do you take walk-in patients?",
    answer: "We work strictly by appointments, which means if you don't have an appointment you can't have a consultation with our doctors. A standard consultation takes 15 minutes. If one of our doctors has an availability they will offer that time slot to you, but you would have to wait."
  },
  {
    question: "Can I book a video or phone consultation?",
    answer: "Yes, we offer integrated telehealth services for follow-up appointments and routine chronic management."
  },
  {
    question: "Do you accept Medical Aids or Cash?",
    answer: "Both, we accept most medical aids as well as cash."
  }
];

export const coreValueProps = [
  {
    id: 'holistic',
    title: 'Holistic Care',
    icon: 'vital_signs',
    features: ['Diagnosing Patients as a whole person', 'Caring for Every Step of the Way', 'Advanced Care Personalized Touch'],
    gradient: 'from-blue-400 to-indigo-500',
    shadow: 'shadow-blue-500/20'
  },
  {
    id: 'preventive',
    title: 'Preventative Care',
    icon: 'cardiology',
    features: ['Primary Health Care', 'General Medical Examinations and Screening', 'Comprehensive Patient Wellness'],
    gradient: 'from-rose-400 to-pink-500',
    shadow: 'shadow-rose-500/20'
  },
  {
    id: 'family',
    title: 'Family Medicine',
    icon: 'diversity_1',
    features: ['Diagnosis and Treatment of Children', 'Restoring family health, revitalising life', 'Comprehensive Familial Member Care'],
    gradient: 'from-amber-400 to-orange-500',
    shadow: 'shadow-orange-500/20'
  }
];

export const partners = [
  {
    name: "Discovery Health",
    logo: "https://ik.imagekit.io/6dlukcyok/Medical%20bucket/discovery-logo-removebg-preview.png"
  },
  {
    name: "Anglo Medical Scheme",
    logo: "https://ik.imagekit.io/6dlukcyok/Medical%20bucket/anglo%20med.avif"
  },
  {
    name: "AngloVaal Group",
    logo: "https://ik.imagekit.io/6dlukcyok/Medical%20bucket/anglovaal-removebg-preview.avif"
  },
  {
    name: "Medical Partner",
    logo: "https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Screenshot%202026-02-17%20at%2014.12.24.avif"
  },
  {
    name: "Netcare",
    logo: "https://ik.imagekit.io/6dlukcyok/Medical%20bucket/netcare.avif"
  }
];
